import { ObservableModel } from "@/shared/lib/observable-model";

export type UpdateFn = (reload?: boolean) => Promise<void>;

export type PwaUpdateSnapshot = Readonly<{
  updater: UpdateFn | null;
  dismissed: boolean;
}>;

class PwaUpdateModel extends ObservableModel<PwaUpdateSnapshot> {
  private state: PwaUpdateSnapshot = { updater: null, dismissed: false };

  get snapshot(): PwaUpdateSnapshot {
    return this.state;
  }

  readonly notifyAvailable = (updater: UpdateFn): void => {
    this.state = { updater, dismissed: false };
    this.notify();
  };

  readonly dismiss = (): void => {
    if (this.state.dismissed) return;

    this.state = { ...this.state, dismissed: true };
    this.notify();
  };
}

export const pwaUpdateModel: PwaUpdateModel = new PwaUpdateModel();
